import { omit } from 'lodash';
import { SERVICE_READONLY_FIELDS } from '@onward-delivery/core';

export const buildServicesSavePayload = ({ pricedServices, cloneServices, orderServices, orderId }) => {
    const safeServices = Array.isArray(pricedServices) ? pricedServices : cloneServices || orderServices || [];

    const services = safeServices.map((service) => ({
        ...omit(service, SERVICE_READONLY_FIELDS),
        order_id: orderId,
    }));

    const editedServiceIds = new Set(safeServices.map((service) => service.service_id).filter(Boolean));
    const servicesRemoved = (orderServices || [])
        .filter((service) => service.service_id && !editedServiceIds.has(service.service_id))
        .map((service) => service.service_id);

    return { services, servicesRemoved };
};
